import { render } from "./ListClaims.vue?vue&type=template&id=9a73b940&scoped=true&ts=true"
import script from "./ListClaims.vue?vue&type=script&lang=ts"
export * from "./ListClaims.vue?vue&type=script&lang=ts"

import "./ListClaims.vue?vue&type=style&index=0&id=9a73b940&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a73b940"]])

export default __exports__